import { MatchTypeKey, MatchTypeValue, TooltipLabelMapping } from './types';

export const MATCH_TYPE: Record<MatchTypeKey, MatchTypeValue[]> = {
  exact: ['ExactMatch', 'Match', 'SHOW', true],
  mismatch: ['HIDE', 'NoMatch', false],
  partial: ['PartialMatch', 'MonthYearMatch', 'DayMonthMatch', 'YearMatch'],
  unknown: ['NA', null],
};

export const OTHER_ID = 'other_id';

export const TOOLTIP_LABELS: TooltipLabelMapping = {
  criminalHit: {
    reported: `The hit is surfaced in the applicant report, partner report, and PDF version of partner report and can be considered a disqualifying reason.`,
    notReported: `The hit is not surfaced in the applicant report, partner report, and PDF version of partner report and cannot be considered a disqualifying reason.`,
  },
  override_logic: {
    hide: `This record is enforced not to be reported.`,
    na: `This record doesn’t have an enforcement.`,
    show: `This record is enforced to be reported.`,
  },
};
